import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild
} from '@angular/core';

import { ContextMenuActionType, IContextMenuGridAction } from '../../../prisma-xs/models/prisma-xs.model';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-prisma-xs-menu-context',
    templateUrl: './menu-context.component.html',
    styleUrls: ['./menu-context.component.scss', '../../scss/context-menu.scss'],
    standalone: false
})
export class MenuContextComponent {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @ViewChild('userMenu', { static: true }) userMenu: TemplateRef<any>;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() contextMenuActionType: any;
  @Input() articleToCopy: boolean;
  @Input() isEditableProject: boolean;
  @Input() thereAreDeprecatedProducts = false;

  @Output() contextMenuActionData = new EventEmitter<IContextMenuGridAction>();

  contextMenuAction(actionType: ContextMenuActionType, ref?: string, event?: MouseEvent) {
    this.contextMenuActionData.emit({ type: actionType, uuid: ref, mousePosition: { top: event?.clientY, left: event?.clientX } });
  }
}
